import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';

/**
 * The matrix of the last run: the lower base rate per hotel and region, against the base region,
 * over the next 10 nights. The backend compares individual raw choices from one completed country-run request.
 */
export const FIND_PROMOTION_COUNTRY_OVERVIEW_QUERY: GraphQL = {
	name: 'findPromotionCountryOverview',
	gql: gql`
		query findPromotionCountryOverview($companyHotelId: Long!) {
			findPromotionCountryOverview(companyHotelId: $companyHotelId) {
				baseRegion
				run { requestId startedAt finishedAt firstNight lastNight regions nightsCompared }
				rows {
					hotelId hotelName main preferredTier
					cells { region discount partial plansDiscounted plansMatched nightsCompared nightsWithDiscount }
				}
				hotelsWithCountryRate
			}
		}
	`,
};

/** READY, IN_PROGRESS with the progress of the run, or COOLDOWN: one run per hotel per hour. */
export const GET_PROMOTION_COUNTRY_RUN_STATUS_QUERY: GraphQL = {
	name: 'getPromotionCountryRunStatus',
	gql: gql`
		query getPromotionCountryRunStatus($companyHotelId: Long!) {
			getPromotionCountryRunStatus(companyHotelId: $companyHotelId) {
				status requestId progressPercentage retryAfterSeconds failed
			}
		}
	`,
};

/**
 * One press: one manual market-state request for the next 10 nights, provider BOOKING, platform WEB,
 * fanned out by the processor to every market-state region except the ones the base region
 * already covers (Greece for a European base: the EEA is one booking.com market).
 */
export const TRIGGER_PROMOTION_COUNTRY_RUN_MUTATION: GraphQL = {
	name: 'triggerPromotionCountryRun',
	gql: gql`
		mutation triggerPromotionCountryRun($companyHotelId: Long!) {
			triggerPromotionCountryRun(companyHotelId: $companyHotelId) {
				status requestId progressPercentage retryAfterSeconds failed
			}
		}
	`,
};
